import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { AppProvider, useApp } from "@/lib/app";
import Shell, { Plain } from "@/components/Shell";
import { AiLoader, ErrorCard } from "@/components/bits";
import Login from "@/pages/Login";
import Start, { JoinLink } from "@/pages/Start";
import Setup from "@/pages/Setup";
import HomePage from "@/pages/Home";
import Tasks from "@/pages/Tasks";
import Unload from "@/pages/Unload";
import Meals from "@/pages/Meals";
import Family from "@/pages/Family";
import Helpers from "@/pages/Helpers";
import Notifications from "@/pages/Notifications";
import Story from "@/pages/Story";
import Checkin from "@/pages/Checkin";
import Legal, { DeleteAccount } from "@/pages/Legal";
import Elder from "@/pages/Elder";

function Gate({ children, nav = true, shell = true }) {
  const { loading, signedIn, me, meError, refresh } = useApp();
  const loc = useLocation();
  if (!signedIn && !loading) return <Navigate to="/login" replace />;
  if (loading || (!me && !meError)) return <Plain><div className="pt-24"><AiLoader kind="type" /></div></Plain>;
  if (meError) return <Plain><div className="pt-24"><ErrorCard text="We couldn't open your home." onRetry={refresh} /></div></Plain>;
  if (me.state !== "ready" && loc.pathname !== "/start") return <Navigate to="/start" replace />;
  return shell ? <Shell nav={nav}>{children}</Shell> : children;
}

const AuthPage = ({ children }) => (
  <Plain><div className="flex justify-center pt-10">{children}</div></Plain>
);

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <AppProvider>
          <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Nunito Sans", fontWeight: 700, borderRadius: 14 } }} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
            <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            <Route path="/join" element={<JoinLink />} />
            <Route path="/d/:token" element={<Elder />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="/start" element={<Gate shell={false}><Start /></Gate>} />
            <Route path="/setup" element={<Gate shell={false}><Setup /></Gate>} />
            <Route path="/story" element={<Gate shell={false}><Story /></Gate>} />
            <Route path="/" element={<Gate><HomePage /></Gate>} />
            <Route path="/tasks" element={<Gate><Tasks /></Gate>} />
            <Route path="/unload/:mode" element={<Gate><Unload /></Gate>} />
            <Route path="/meals" element={<Gate><Meals /></Gate>} />
            <Route path="/family" element={<Gate><Family /></Gate>} />
            <Route path="/helpers" element={<Gate><Helpers /></Gate>} />
            <Route path="/notifications" element={<Gate><Notifications /></Gate>} />
            <Route path="/checkin" element={<Gate><Checkin /></Gate>} />
            <Route path="/delete-account" element={<Gate><DeleteAccount /></Gate>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
